import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询后台模型类型列表
export const queryBackTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setBackTypes', { ...state.backTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/BackType');
    commit('setBackTypes', { data: res, loading: false });
  } catch (e) {
    commit('setBackTypes', { data: [], loading: false });
  }
};

// 查询实体类型列表
export const queryEntityTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setEntityTypes', { ...state.entityTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/FilterItemEntityType');
    commit('setEntityTypes', { data: res, loading: false });
  } catch (e) {
    commit('setEntityTypes', { data: [], loading: false });
  }
};

// 查询平面图类型列表
export const queryFlagImageTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setFlagImageTypes', { ...state.flagImageTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/ItemFlatImage');
    commit('setFlagImageTypes', { data: res, loading: false });
  } catch (e) {
    commit('setFlagImageTypes', { data: [], loading: false });
  }
};

// 查询过滤项类型列表
export const queryFilterTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setFilterTypes', { ...state.filterTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/ModelType');
    commit('setFilterTypes', { data: res, loading: false });
  } catch (e) {
    commit('setFilterTypes', { data: [], loading: false });
  }
};

// 查询表面材料类型
export const queryMaterialTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setMaterialTypes', { ...state.materialTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/MaterialType');
    commit('setMaterialTypes', { data: res, loading: false });
  } catch (e) {
    commit('setMaterialTypes', { data: [], loading: false });
  }
};

// 查询全部表面材料类型
export const queryMaterialFullTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setMaterialFullTypes', { ...state.materialFullTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/MaterialTypeFull');
    commit('setMaterialFullTypes', { data: res, loading: false });
  } catch (e) {
    commit('setMaterialFullTypes', { data: [], loading: false });
  }
};

// 查询物料状态列表
export const queryStatusTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setStatusTypes', { ...state.statusTypes, loading: true });
    const res: any[] = await $http.get('/common/chooseoptions/TypeItemStatus');
    const data =  [{ optionKey: '', optionValue: '全部' } , ...res];
    commit('setStatusTypes', { data, loading: false });
  } catch (e) {
    commit('setStatusTypes', { data: [], loading: false });
  }
};

// 查询表面材料可摆放类型
export const querySurfaceTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setSurfaceTypes', { ...state.surfaceTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/SurfaceType');
    commit('setSurfaceTypes', { data: res, loading: false });
  } catch (e) {
    commit('setSurfaceTypes', { data: [], loading: false });
  }
};

// 查询价格单位下拉列表
export const queryUnitTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setUnitTypes', { ...state.unitTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/Unit');
    commit('setUnitTypes', { data: res, loading: false });
  } catch (e) {
    commit('setUnitTypes', { data: [], loading: false });
  }
};

// 查询灯具配置类型
export const queryLuminorConfigTypes: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setLuminorConfigTypes', { ...state.luminorConfigTypes, loading: true });
    const res = await $http.get('/common/chooseoptions/LuminorConfigType');
    commit('setLuminorConfigTypes', { data: res, loading: false });
  } catch (e) {
    commit('setLuminorConfigTypes', { data: [], loading: false });
  }
};
